import { useQuery } from '@tanstack/react-query'

import { api, unwrap } from '@shared/api/client'

export const MESSAGE_REQUESTS_KEY = ['message-requests'] as const

export function useMessageRequests() {
  return useQuery({
    queryKey: MESSAGE_REQUESTS_KEY,
    queryFn: async () => unwrap(await api.GET('/message-requests')).items,
    refetchInterval: 15_000,
    refetchOnWindowFocus: true,
  })
}
